<div class="tasks-list scrollable-content">
  @if (data) {
    <div class="tasks-list__header">
      <h1 class="tasks-list__title">
        Tareas del {{ data.date | date : "d 'de' MMMM 'de' y" }}
      </h1>
      <span class="tasks-list__count">{{ events.length }} {{ events.length === 1 ? 'tarea' : 'tareas' }}</span>
      <button type="button" class="tasks-list__close" mat-icon-button mat-dialog-close aria-label="Cerrar" title="Cerrar">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
  }
  <div class="tasks-list__body historic">
    @if (events.length == 0) {
      <p class="tasks-list__empty">No se encontraron tareas para mostrar</p>
    }
    <mat-accordion class="task-list-accordion">
      @for (event of events; track event) {
        <mat-expansion-panel
          hideToggle="true"
          [ngClass]="{
            'pending-contact': applyPendingContactStyle(event.event.data)
          }"
          >
          <mat-expansion-panel-header
            #panelH
            >
            <div class="task-row">
              <div class="task-row__info">
                <h4 class="task-row__title">
                  @if (event.event.data.fromMobile) {
                    <img
                      class="mobile-img"
                      src="../../../../assets/icons/common/mobile.svg"
                      alt="mobile phone"
                      />
                  }
                  @if (event.event.data.isPromotional) {
                    <img
                      class="promo-img"
                      src="../assets/icons/promotional-icon/promotional-icon.png"
                      alt=""
                      />
                  }
                  {{ getThirdPartyAppName(event.event.data.fromThirdPartyApp) }}
                  {{ event.event.data.jobGroup }}
                  {{ event.event.data.taskType }}
                </h4>
                @if (!data) {
                  <span>Fecha programada:
                    {{ event.event.data.schudeledDate | date : "dd/MM/yyyy" }}</span>
                }
                @if (event.event.data.productName != null) {
                  <span>Producto: {{ event.event.data.productName }}</span>
                }
                @if (event.event.data.productColorName != null) {
                  <span>Color: {{ event.event.data.productColorName }}</span>
                }
                @if (event.event.data.productQualityName != null) {
                  <span>Calidad: {{ event.event.data.productQualityName }}</span>
                }
                <span>Localidad: {{ event.event.data?.clientCity ?? "" }}</span>
              </div>
              <div class="task-row__status">
                <span class="tp-badge task-status">
                  <span class="status-dot" [style.background-color]="getStatusSelectedColor(event.event.data.status)"></span>
                  {{ getStatusDescription(event.event.data.status) }}
                </span>
              </div>
              <div class="task-row__actions">
                <button
                  type="button"
                  (click)="$event.stopPropagation(); dialogAction(event)"
                  mat-stroked-button
                  class="detail-button"
                  [disabled]="event.event.data.isReadOnly"
                  >
                  Ver detalle
                </button>
                <button
                  type="button"
                  (click)="$event.stopPropagation(); expandDetail(event.event.data.id); panelH._toggle()"
                  title="Expandir vista previa"
                  aria-label="Expandir vista previa"
                  class="expand-button"
                  mat-icon-button
                  >
                  <img
                    [ngClass]="
                      selectedId == event.event.data.id
                        ? 'transfor-rotate-180'
                        : ''
                    "
                    src="../../../../assets/icons/common/expansion.svg"
                    alt=""
                    />
                </button>
              </div>
            </div>
          </mat-expansion-panel-header>
          <dl class="task-row__details">
            <div><dt>Domicilio</dt><dd>{{ event.event.data?.clientAddress ?? "" }}</dd></div>
            <div><dt>Cliente</dt><dd>{{ event.event.data.clientName }}</dd></div>
            <div><dt>Hora</dt><dd>{{ event.event.data.schudeledDate | date : "hh:mm a" }}</dd></div>
            <div><dt>Teléfono</dt><dd>{{ event.event.data?.clientPhone ?? "" }}</dd></div>
          </dl>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>
